import Logo from 'components/common/Logo';
import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ margin: 0, fontFamily: `'Segoe UI', Tahoma, Geneva, Verdana, sans-serif`, backgroundColor: '#f8f9fa', color: '#555' }}>
      <header style={{
        background: 'white',
        borderBottom: '1px solid #e0e0e0',
        display: 'flex',
        alignItems: 'center',
        padding: '20px 30px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.06)'
      }}>
        {/* <img src="/assets/img/logos/LogoImage.png" alt="Map Your Meds" style={{ height: '50px', marginRight: '15px' }} /> */}
         <Logo width={250} />
      </header>

      <div style={{
        maxWidth: '900px',
        margin: '40px auto',
        background: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 0 24px rgba(0, 0, 0, 0.04)'
      }}>
        <h1 style={{ fontSize: '28px', color: '#333', marginBottom: '10px' }}>Privacy Policy</h1>
        <p><strong>Effective Date:</strong> March 31, 2025</p>
        <p><strong>Last Updated:</strong> March 31, 2025</p>

        <p>Map Your Meds (“we,” “our,” or “us”) operates under a licensed pharmacy based in the United States. 
        This Privacy Policy describes how we collect, use, and safeguard your information through our mobile 
        application designed for licensed nursing professionals to monitor and update medication administration for patients.</p>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>1. Information We Collect</h2>

        <h3 style={{ color: '#333', marginTop: '20px', fontSize: '16px' }}>a. Personal Information (Nurses):</h3>
        <ul style={{ margin: '10px 0 20px 20px', paddingLeft: '15px' }}>
          <li>Full name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Nursing license ID</li>
        </ul>

        <h3 style={{ color: '#333', marginTop: '20px', fontSize: '16px' }}>b. Patient-Related Data (HIPAA-Compliant):</h3>
        <ul style={{ margin: '10px 0 20px 20px', paddingLeft: '15px' }}>
          <li>Non-identifiable patient ID</li>
          <li>Medication details</li>
          <li>Dosage and administration times</li>
          <li>Notes added by the nurse</li>
        </ul>

        <h3 style={{ color: '#333', marginTop: '20px', fontSize: '16px' }}>c. Device & Usage Information:</h3>
        <ul style={{ margin: '10px 0 20px 20px', paddingLeft: '15px' }}>
          <li>IP address</li>
          <li>Device type and operating system</li>
          <li>App version</li>
          <li>Crash logs and performance data</li>
        </ul>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>2. How We Use Your Information</h2>
        <p>We collect this data to:</p>
        <ul style={{ margin: '10px 0 20px 20px', paddingLeft: '15px' }}>
          <li>Provide secure login and personalized nurse profiles</li>
          <li>Enable accurate medication tracking and logs</li>
          <li>Improve app functionality and user experience</li>
          <li>Comply with pharmacy and healthcare regulations</li>
        </ul>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>3. Data Sharing & Disclosure</h2>
        <p>We do not sell your personal data. We may share your information with:</p>
        <ul style={{ margin: '10px 0 20px 20px', paddingLeft: '15px' }}>
          <li>Healthcare providers for coordination of patient care</li>
          <li>Regulatory bodies when required by law</li>
          <li>Trusted third-party service providers (e.g., Firebase, AWS) who are compliant with HIPAA</li>
        </ul>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>4. Data Security</h2>
        <p>We implement strong security protocols and utilize HIPAA-compliant cloud infrastructure to keep your data safe. Access is restricted to authorized personnel only.</p>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>5. Your Rights</h2>
        <p>You have the right to:</p>
        <ul style={{ margin: '10px 0 20px 20px', paddingLeft: '15px' }}>
          <li>Access your personal information</li>
          <li>Request corrections</li>
          <li>Request account deletion (see Account Deletion Policy)</li>
          <li>Withdraw consent for non-essential data collection</li>
        </ul>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>6. Children’s Privacy</h2>
        <p>Our app is strictly intended for use by licensed healthcare professionals and is not directed at children under 13. We do not knowingly collect information from minors.</p>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>7. Data Retention</h2>
        <p>We retain data as necessary to meet legal, operational, and regulatory requirements. Patient-related data is retained in accordance with HIPAA-compliant pharmacy standards.</p>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>8. Changes to This Policy</h2>
        <p>We may update this Privacy Policy periodically. Users will be notified of any major updates through email or in-app notices.</p>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>9. Contact Us</h2>
        <p>Email: <a href="mailto:support@mapyourmeds.com">support@mapyourmeds.com</a></p>
        <p>Phone: +1 (469) 400-5176</p>

        <h2 style={{ color: '#0d6efd', marginTop: '40px', fontSize: '20px', borderBottom: '2px solid #0d6efd', paddingBottom: '6px' }}>Address</h2>
        <p>Map Your Meds Inc</p>
        <p>21 Green St</p>
        <p>Waltham</p>
        <p>Boston</p>
        <p>02451 Massachusetts</p>
        <p>U.S.A</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
